import { render, staticRenderFns } from "./BrowseToFileModal.vue?vue&type=template&id=410dd848&scoped=true"
import script from "./BrowseToFileModal.vue?vue&type=script&lang=ts"
export * from "./BrowseToFileModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410dd848",
  null
  
)

export default component.exports